import React, { useSyncExternalStore } from "react";
import { motion, AnimatePresence } from "framer-motion";
import AchievementBadge from "./AchievementBadge";
import "./CoinBurst.css";

const SPARKS = Array.from({ length: 12 }, (_, i) => ({ x: Math.cos(i * Math.PI / 6) * 135, y: Math.sin(i * Math.PI / 6) * 95 - 30, color: ["#fbbf24", "#A78BFA", "#a78bfa", "#fb7185"][i % 4] }));

// React to preference changes while this screen stays mounted.
const motionQuery = "(prefers-reduced-motion: reduce)";
const readMotionPreference = () => window.matchMedia(motionQuery).matches;
function subscribeToMotionPreference(onChange) {
  const query = window.matchMedia(motionQuery);
  query.addEventListener("change", onChange);
  return () => query.removeEventListener("change", onChange);
}

export default function CoinBurst({ show, label = "Nice work!", variant = "success" }) {
  const reduced = useSyncExternalStore(subscribeToMotionPreference, readMotionPreference, () => true);
  return <AnimatePresence>{show && (
    <motion.div className="quest-celebration" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} role="status" aria-live="polite" data-testid="kid-celebration">
      <motion.div className="celebration-card" initial={reduced ? false : { y: 25, scale: .9 }} animate={{ y: 0, scale: 1 }} transition={{ type: "spring", stiffness: 280, damping: 22 }}>
        {!reduced && SPARKS.map((spark, i) => <motion.span key={i} className="celebration-spark" aria-hidden="true" style={{ background: spark.color }} initial={{ x: 0, y: 0, opacity: 1, rotate: 0 }} animate={{ x: spark.x, y: spark.y, opacity: 0, rotate: i * 45 }} transition={{ duration: .85, ease: "easeOut" }} />)}
        <AchievementBadge icon={variant === "level" ? "trophy" : variant === "reward" ? "gift" : "check"} size={64} />
        <div><span className="celebration-kicker">{variant === "level" ? "NEW LEVEL UNLOCKED" : variant === "reward" ? "GOOD CHOICE" : "LOOK AT YOU GO"}</span><p>{label}</p></div>
      </motion.div>
    </motion.div>
  )}</AnimatePresence>;
}
